import { useEffect, useState } from "react";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

import { ToggleField } from "@components/forms/toggle.field";

const SECONDS_IN_DAY = 24 * 60 * 60;

const offlineModeOptions = [
  {
    label: "1 day",
    value: SECONDS_IN_DAY,
  },
  {
    label: "2 days",
    value: SECONDS_IN_DAY * 2,
  },
  {
    label: "3 days",
    value: SECONDS_IN_DAY * 3,
  },
  {
    label: "7 days",
    value: SECONDS_IN_DAY * 7,
  },
];

const getSelectedOption = (value) => {
  return offlineModeOptions.find((option) => option.value === value);
};

export const OfflineModeToggle = ({
  enabled,
  description,
  onToggle,
  onValueChange,
  loading,
  value,
  hidden,
}) => {
  const [selectedOption, setSelectedOption] = useState(
    getSelectedOption(value),
  );

  const handleChange = (option) => {
    setSelectedOption(option);
    onValueChange(option?.value);
  };

  useEffect(() => {
    if (enabled) {
      const option = getSelectedOption(value);

      if (option) {
        setSelectedOption(option);
      } else {
        handleChange(option);
      }
    }
  }, [enabled, value]);

  if (!loading && hidden) {
    return null;
  }

  return (
    <ToggleField
      className="offline-mode-toggle"
      label={!hidden ? "Offline Mode" : undefined}
      description={description}
      value={enabled}
      onChange={onToggle}
      required={!hidden}
      loading={loading}
    >
      <Dropdown
        selected={selectedOption}
        onOptionSelected={handleChange}
        disabled={!enabled}
      >
        <DropdownButton placeholder="Select duration in days...">
          {selectedOption?.label}
        </DropdownButton>
        <DropdownItems>
          {offlineModeOptions.map((option) => (
            <DropdownItem key={option.value} value={option}>
              {option.label}
            </DropdownItem>
          ))}
        </DropdownItems>
      </Dropdown>
    </ToggleField>
  );
};
